import React from 'react';
import MultiSearchSelect from '../../../components/Forms/Input/MultiSearchSelect';
import { roleLabel } from '../../../constants/roleLabels';

interface RoleOption {
  id: number;
  name: string;
  label?: string;
}

interface Props {
  form: { roleIds: number[] };
  options: RoleOption[];
  onChange: (field: string, value: any) => void;
  errors: Record<string, string>;
}

const UserRoleSelector: React.FC<Props> = ({ form, options, onChange, errors }) => {
  return (
    <MultiSearchSelect
      label="Roles"
      name="roleIds"
      iconKey="userCheck"
      selectedValues={form.roleIds}
      onChange={(values) => onChange('roleIds', values)}
      options={options.map((r) => ({
        id: r.id,
        name: r.label ?? roleLabel(r.name),
      }))}
      searchPlaceholder="Buscar rol..."
      required
      error={errors.roleIds}
    />
  );
};

export default UserRoleSelector;
